import { FloatingIconButton, IconType } from "@livingmap/core-ui-v2";
import classNames from "classnames";

import styles from "./LocationButton.module.scss";

export enum LocationStatus {
  INACTIVE = "inactive",
  SEARCHING = "searching",
  FOUND = "found",
  DISABLED = "disabled",
  OUTOFBOUNDS = "out_of_bounds",
}

interface Props {
  dataQA: string;
  className?: string;
  status: LocationStatus;
  theme?: "light" | "dark";
  size?: "small" | "medium" | "large";
  colour?: "blue" | "red" | "green";
  onClick: () => void;
}

const LocationButton: React.FC<Props> = ({
  dataQA,
  className,
  status,
  theme = "light",
  size = "small",
  colour = "blue",
  onClick,
}) => {
  let iconType: IconType = "NearMeOutlineIcon";

  switch (status) {
    case LocationStatus.FOUND:
      iconType = "NearMeIcon";
      break;
    case LocationStatus.DISABLED:
      iconType = "NearMeDisabledOutlineIcon";
      break;
    default:
      iconType = "NearMeOutlineIcon";
  }

  return (
    <FloatingIconButton
      dataQA={dataQA}
      icon={iconType}
      onClick={onClick}
      rounded
      theme={theme}
      size={size}
      className={classNames(styles.container, styles[theme], className, {
        [styles.found]: status === LocationStatus.FOUND,
        [styles.searching]: status === LocationStatus.SEARCHING,
        [styles[colour]]: status === LocationStatus.FOUND,
      })}
    />
  );
};

export default LocationButton;
